import { Component, Input, OnChanges, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-bill-details-row',
  templateUrl: './bill-details-row.component.html',
  styleUrls: ['./bill-details-row.component.scss'],
})
export class BillDetailsRowComponent implements OnChanges {
  @Input() content: string;
  @Input() tooltip: string;
  @Input() label: string;
  @Input() price: string;
  @Input() badge: string;

  private _sanitizedContent: SafeHtml;

  constructor(
    private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      if (!this.content) {
        this._sanitizedContent = '';
        return;
      }
      this._sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, this.content);
    }
  }

  get sanitizedContent(): SafeHtml {
    return this._sanitizedContent;
  }
}
